/**
 * b2c配置api
 */
import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();

export function getB2cList(params) {
    /**查询语言的信息 */
    return api.get('/api/b2c/', params)
}

export function postB2c(params) {
    /**设置 语言的信息 */
    return api.post(`/api/b2c/`, params)
}

export function putB2c(id, params) {
    /**设置 语言的信息 */
    return api.put(`/api/b2c/${id}/`, params)
}
export function deleteB2c(id) {
    /**设置 语言的信息 */
    return api.delete(`/api/b2c/${id}/`)
}

export function getB2cByUser() {
    /**当前登录用户查询是否配置企业商城信息*/
    return api.get(`/api/b2c_company`)
}